:host {
  background: var(--white-layout-301-level-0-elevation);
}

.page__header {
  padding: calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2.5 * var(--spacer));
}

.wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-y: auto;
  padding-bottom: var(--spacer);

  .grid-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;

    --filter-grid-border: none;

    gz-grid-view {
      --grid-row-hover-background: var(--white-layout-301-level-0-elevation);
    }

    [hidden] {
      display: none;
    }

    #page-title {
      padding-top: 17px;
      padding-left: 24px;
    }

    .customer-wrapper {
      max-width: 950px;

      [hidden] {
        display: none;
      }
    }
  }
}
